<template>
  <div>
     <div class="container-fluid my-account">
         <div class="row">
             <div class="col-md-12 page_title">
                    Account
             </div>
         </div>
         <div class="row ">
             <div class="col-md-12">
         <div class="success_message" v-text="this.$root.success_message" v-if="this.$root.success_message != ''"></div>
            <div class="error_message" v-text="this.$root.error_message" v-if="this.$root.error_message != ''"></div>
         </div>
             <div class="col-md-2 account_sidebar">
                <ul class="sidebar">
                    <li class="sidebar_list active"><router-link :to="{name:'dashboard'}">Overview</router-link></li>
                    <li class="sidebar_list">
                        <h4 class="sidebar_heading">Orders & returns </h4>
                        <router-link :to="{name:'order'}">My Orders</router-link>
                        </li>
                    <li class="sidebar_list">
                          <h4 class="sidebar_heading">Account </h4>
                           <router-link :to="{name:'profile'}">Profile</router-link>
                           <!-- <router-link :to="{name:'address_book'}">Saved Cards</router-link> -->
                            <router-link :to="{name:'address_book'}">Address</router-link>
                    </li>
					<li class="sidebar_list">
							<h4 class="sidebar_heading">Credits</h4>
							<router-link :to="{ name: 'StoreCredit' }">WNDW Credits</router-link>
						</li>
                </ul>
             </div>
        		<PuSkeleton  class="col-md-10 Skeleton1"  width="100%" height="60vh" v-if="profileLoader"  />
             <div class="col-md-10 account_detail bg-white" v-else>
                <div class="row">
                     <div class="col-md-12 text-center">
                       
                         <div class="content-box">
                             <p class="dashName" v-text="this.customer_name"></p>
                             <p class="dashEmail" v-text="this.customer_email"></p>
                             <p class="dashPhone" v-text="this.customer_phone"></p>
                             <a href="#" class="btnEdit" @click.prevent="edit_contact">Edit Profile</a>
                         </div>
        <form class="new-address-form opc-section row text-left" v-if="isEdit">
              <div class="form-group col-md-6 full-name " v-bind:class="{success : this.name_error == '' , error : this.name_error != ''}">
                  <label class="label"><span>Full Name</span></label>
                  <input class="input-text form-control" v-model="customer_name"  autocomplete="off" @keyup="cust_name" type="text" name="full_name" required="">
                  <p class="size_error" v-text="this.name_error"></p>
              </div>
              <div class="form-group col-md-6 email" v-bind:class="{success : this.email_error == '' , error : this.email_error != ''}">
                  <label class="label"><span>Email</span></label>
                  <input class="input-text form-control" type="email" autocomplete="off" @keyup="cust_email" v-model="customer_email" name="Email" required="">
                  <p class="size_error" v-text="this.email_error"></p>
              </div>
              <div class="form-group col-md-12 receiver-phone" v-bind:class="{success : this.phone_error == '' , error : this.phone_error != ''}">
                  <label class="label"><span>Receiver Phone Number</span></label>
                  <input class="input-text form-control" maxlength="10" autocomplete="off" @keyup="cust_phone" readonly v-model="customer_phone" type="text" name="phone" required="">
                  <p class="size_error" v-text="this.phone_error"></p>
              </div>
              <div class="form-group col-md-12 submit text-center">
                  <button type="button" @click="update_contact" v-ripple class="continue">
                      <span>Update</span>
                  </button>
              </div>
          </form>
                     </div>
                </div>
                      <div class="linksContainer">
                          <div class="accountLinks">
                               <router-link :to="{name:'order'}">
								   <img src="/img/order.png" height="50" /> <br>
                                    Orders
							 </router-link>
                          </div>
                           <!-- <div class="accountLinks">
                              <img src="/img/card.png" width="42"/>
                              <router-link :to="{name:'order'}">Cards</router-link>
                          </div> -->
                           <div class="accountLinks">
                              <router-link :to="{name:'address_book'}">
								<img src="/img/address.png"  height="50"/> <br>
								 Addresses 
							 </router-link>
                          </div>
                           <div class="accountLinks">
                              <router-link :to="{name:'profile'}">
								<img src="/img/profile.png" height="50"/> <br>
									Profile
							 </router-link>
                          </div>
						  <div class="accountLinks">
                               <router-link :to="{name:'StoreCredit'}">
								   <img src="/img/credit.png" height="50" /> <br>
                                    WNDW Credits
							 </router-link>
                          </div>
                      </div>
                     <!-- <div class="col-md-12">
                         <h4 class="main-heading">Default Shipping Address <router-link :to="{name:'address_book'}" class="pull-right">Manage Addresses</router-link></h4>
                         <div class="content-box" v-if="this.shipping_address.address!=''">
                             <p v-text="this.shipping_address.name"></p>
                             <p v-text="this.shipping_address.city"></p>
                             <p v-text="this.shipping_address.address +', '+ this.shipping_address.state +', '+ this.shipping_address.pincode"></p>
                             <p v-text="this.shipping_address.email"></p>
                             <p v-text="this.shipping_address.phone"></p>
                             <a href="#" @click.prevent="edit_address(shipping_address.address_id,shipping_address.name,shipping_address.address,shipping_address.city,shipping_address.state,shipping_address.pincode,shipping_address.phone,shipping_address.default)">Edit</a>
                         </div> -->
                         <!-- <div class="content-box" v-else>
                             <p>No Address found</p>
                         </div> -->
                     <!-- </div> -->
                     <!-- <div class="col-md-12">
                         <h4 class="main-heading border-none">Recent Orders <router-link :to="{name:'order'}" class="pull-right">View All</router-link></h4>
                         <div class="content-box">
                             <table class="table order-table">
                              <thead>
                                <tr>
                                  <th>Order #</th>
                                  <th>Date</th>
                                  <th>Ship To</th>
                                  <th>Order Total</th>
                                  <th class="text-right">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(items,index) in order"  v-if="index <= 5">
                                  <td v-text="items.order_increment_id" class="order"></td>
                                  <td v-text="items.order_date" class="order-date"></td>
                                  <td v-text="items.shipping_name" class="name"></td>
                                  <td v-text="'Rs. '+items.grand_total" class="total"></td>
                                  <td class="action text-right"><button class="order-with-cod" v-if="items.showCOD == 1" @click="order_with_cod(items.order_quote_id)">Reorder with <span>CASH ON DELIVERY</span></button> <a href="#" v-if="items.showCOD != 1" @click.prevent="reorder(items.order_quote_id)" class="reorder">Reorder</a> <router-link :to="{name:'order-detail' , path: '/order-detail.html' , params: {id: items.order_quote_id} , query: {id: items.order_quote_id}}">View Order</router-link></td>
                                </tr>
                              </tbody>
                            </table>
                            <p v-if="!order.length">No Order found</p>
                         </div>
                     </div> -->
                </div>
             </div>

         </div>
         <div id="coupon-modal" class="modal" v-bind:class="[this.address_popup ? '' : 'active']">
         <div class="modal-dialog">
         <div class="modal-content">
         <div class="modal-header">
         <h4 class="modal-title font-bold">Edit Address</h4><button type="button" class="close" @click="close_popup()">×</button></div><div class="modal-body">
         <div class="error_message" v-text="this.$root.error_message" v-if="this.$root.error_message != ''"></div>
        
         <form class="new-address-form opc-section">
              <div class="field full-name" v-bind:class="{success : this.name_error == '' , error : this.name_error != ''}">
                  <label class="label"><span>Full Name</span></label>
                  <input class="input-text form-control" v-model="user.name"  autocomplete="off" @keyup="user_name" type="text" name="full_name" required="">
                  <p class="size_error" v-text="this.name_error"></p>
              </div>
              <div class="field street-address" v-bind:class="{success : this.address_error == '' , error : this.address_error != ''}">
                  <label class="label"><span>Street Address</span></label>
                  <input class="input-text form-control" v-model="user.address" autocomplete="off" @keyup="user_address" type="text" name="street_address" required="">
                  <p class="size_error" v-text="this.address_error"></p>
              </div>
              <div class="field pin-code" v-bind:class="{success : this.pin_code_error == '' , error : this.pin_code_error != ''}">
                  <label class="label"><span>PIN Code</span></label>
                  <input class="input-text form-control" type="text" autocomplete="off" @keyup="user_pin_code" v-model="user.pin_code" name="pin_code" id="postcode" maxlength="6" required="">
                  <p class="size_error" v-text="this.pin_code_error"></p>
              </div>
              <div class="field city" v-bind:class="{success : this.city_error == '' , error : this.city_error != ''}">
                  <label class="label"><span>City</span></label>
                  <input class="input-text form-control" type="text" autocomplete="off" @keyup="user_city" v-model="user.city" name="city" id="city" required="">
                  <p class="size_error" v-text="this.city_error"></p>
              </div>
              <div class="field state" v-bind:class="{success : this.state_error == '' , error : this.state_error != ''}">
                  <label class="label"><span>State</span></label>
                  <input class="input-text form-control" type="text"  autocomplete="off" v-model="user.state" name="state" id="state" required="" disabled>
              </div>
              <div class="field receiver-phone" v-bind:class="{success : this.phone_error == '' , error : this.phone_error != ''}">
                  <label class="label"><span>Receiver Phone Number</span></label>
                  <input class="input-text form-control" maxlength="10" autocomplete="off" @keyup="user_phone" v-model="user.phone" type="text" name="phone" required="">
                  <p class="size_error" v-text="this.phone_error"></p>
              </div>
              <div class="field submit">
                  <button type="button" @click="update_address" v-ripple class="continue">
                      <span>Update Address</span>
                  </button>
              </div>
          </form>
         </div>
         </div>
         </div>
         </div>


         <div class="modal" id="coupon-modal" v-bind:class="[this.account_popup ? '' : 'active']">
         <div class="modal-dialog">
         <div class="modal-content">
         <div class="modal-header">
         <h4 class="modal-title font-bold">Contact Information</h4><button type="button" class="close" @click="close_popup()">×</button></div><div class="modal-body">
         <div class="error_message" v-text="this.$root.error_message" v-if="this.$root.error_message != ''"></div>
        
         <form class="new-address-form opc-section">
              <div class="field full-name" v-bind:class="{success : this.name_error == '' , error : this.name_error != ''}">
                  <label class="label"><span>Full Name</span></label>
                  <input class="input-text form-control" v-model="customer_name"  autocomplete="off" @keyup="cust_name" type="text" name="full_name" required="">
                  <p class="size_error" v-text="this.name_error"></p>
              </div>
              <div class="field email" v-bind:class="{success : this.email_error == '' , error : this.email_error != ''}">
                  <label class="label"><span>Email</span></label>
                  <input class="input-text form-control" type="email" autocomplete="off" @keyup="cust_email" v-model="customer_email" name="Email" required="">
                  <p class="size_error" v-text="this.email_error"></p>
              </div>
              <div class="field receiver-phone" v-bind:class="{success : this.phone_error == '' , error : this.phone_error != ''}">
                  <label class="label"><span>Receiver Phone Number</span></label>
                  <input class="input-text form-control" maxlength="10" autocomplete="off" @keyup="cust_phone" v-model="customer_phone" type="text" name="phone" required="">
                  <p class="size_error" v-text="this.phone_error"></p>
              </div>
              <div class="field submit">
                  <button type="button" @click="update_contact" v-ripple class="continue">
                      <span>Update</span>
                  </button>
              </div>
          </form>
         </div>
         </div>
         </div>
         </div>
     </div>
  </div>
</template>

<script>
	import axios from "axios";
	export default {
		name: "dashboard",
		metaInfo: {
			title: "Dashboard",
			meta: [
				{
					name: "description",
					content:
						"Online fashion shopping destination for the modern women. Buy latest collection of online ethnic wear for women’s, W Kurtas, dresses, bottom wear, tops, palazzos, culottes, skirts, drapes and more.",
				},
				{
					property: "keywords",
					content:
						"Online Shopping for Women,  W for Woman, women’s dresses online, buy women’s dresses online",
				},
			],
		},
		data() {
			return {
				profileLoader:true,
				order: [],
				isEdit: false,
				customer_name: "",
				customer_email: "",
				customer_phone: "",
				shipping_address: {
					address_id: "",
					name: "",
					address: "",
					pincode: "",
					city: "",
					state: "",
					phone: "",
					default: "",
				},
				address_popup: true,
				account_popup: true,
				address_error: "Please enter valid Address",
				email_error: "Please enter valid Email",
				name_error: "Please enter valid Name",
				pin_code_error: "Please enter valid Pin code",
				city_error: "Please enter valid City",
				state_error: "Please enter valid State",
				phone_error: "Please enter valid Phone Number",
				selected_address_pincode: "",
				user: {
					address_id: "",
					name: "",
					address: "",
					pin_code: "",
					city: "",
					state: "",
					phone: "",
					default: "",
				},
			};
		},
		methods: {
			reorder(pcart) {
				this.$root.page_loader = true;
				var form = new FormData();
				form.append("pcart", pcart);
				form.append("customer_id", this.$root.customer_id);
				form.append("customer_session", this.$root.customer_session);
				axios
					.post(this.$root.cart_api + "/order/re-order", form)
					.then((response) => {
						if (response.data.success === true) { 
							this.$cookies.set(
								window.location.hostname.substring(10, 4) + "_cart",
								response.data.data.pcart
							);
							this.$cookies.set(
								window.location.hostname.substring(10, 4) + "_carts",
								response.data.data.cart_session
							);
							this.$root.cart_session = response.data.data.cart_session;
							this.$root.pcart = response.data.data.pcart;
							this.$root.thankyou_cart = response.data.data.pcart;
							this.$router.push("checkout.html");
							this.$root.page_loader = false;
						} else {
							window.scrollTo(0, 0);
							this.$root.page_loader = false;
							this.$root.error_message = response.data.message;
							if (response.data.customer_session_status == false) {
								this.$cookies.set(
									window.location.hostname.substring(10, 4) + "_customer",
									"",
									"1y"
								);
								this.$cookies.set(
									window.location.hostname.substring(10, 4) + "_cs",
									"",
									"1y"
								);
								this.$root.customer_id = "";
								this.$root.customer_session = "";
								this.$cookies.set(
									window.location.hostname.substring(10, 4) + "_cart",
									"",
									"1y"
								);
								this.$cookies.set(
									window.location.hostname.substring(10, 4) + "_carts",
									"",
									"1y"
								);
								this.$root.pcart = "";
								this.$root.cart_session = "";
								this.$root.cart_product = [];
								this.$router.push("/");
							}
						}
					})
					.catch((error) => {
						this.$root.page_loader = false;
						if (error.message === "Network Error") {
							this.$root.error_message =
								"Oops there seems to be some Network issue, please try again.";
						}
						window.scrollTo(0, 0);
					});
			},
			order_with_cod(pcart) {
				this.$root.page_loader = true;
				this.$root.thankyou_cart = pcart;
				var form = new FormData();
				this.$root.thankyou_status = true;
				this.$cookies.set(
					window.location.hostname.substring(10, 4) + "_thank",
					"true"
				);
				form.append("pcart", pcart);
				form.append("customer_id", this.$root.customer_id);
				form.append("customer_session", this.$root.customer_session);
				axios
					.post(this.$root.cart_api + "/order/cod-confirmation", form)
					.then((response) => {
						if (response.data.success === true) {
							this.$cookies.set(
								window.location.hostname.substring(10, 4) + "_cart",
								response.data.data.pcart
							);
							this.$cookies.set(
								window.location.hostname.substring(10, 4) + "_carts",
								response.data.data.cart_session
							);
							this.$root.cart_session = response.data.data.cart_session;
							this.$root.pcart = response.data.data.pcart;
							this.$root.thankyou_cart = response.data.data.pcart;
							this.$router.push("thankyou.html");
						} else {
							this.$root.page_loader = false;
							this.$root.error_message = response.data.message;
							this.$root.thankyou_status = false;
							this.$cookies.set(
								window.location.hostname.substring(10, 4) + "_thank",
								""
							);
							if (response.data.customer_session_status == false) {
								this.$cookies.set(
									window.location.hostname.substring(10, 4) + "_customer",
									"",
									"1y"
								);
								this.$cookies.set(
									window.location.hostname.substring(10, 4) + "_cs",
									"",
									"1y"
								);
								this.$root.customer_id = "";
								this.$root.customer_session = "";
								this.$cookies.set(
									window.location.hostname.substring(10, 4) + "_cart",
									"",
									"1y"
								);
								this.$cookies.set(
									window.location.hostname.substring(10, 4) + "_carts",
									"",
									"1y"
								);
								this.$root.pcart = "";
								this.$root.cart_session = "";
								this.$root.cart_product = [];
								this.$router.push("/");
							}
						}
					})
					.catch((error) => {
						this.$root.page_loader = false;
						this.$root.thankyou_status = false;
						this.$cookies.set(
							window.location.hostname.substring(10, 4) + "_thank",
							""
						);
						if (error.message === "Network Error") {
							this.$root.error_message =
								"Oops there seems to be some Network issue, please try again.";
						}
						window.scrollTo(0, 0);
					});
			},
			close_popup: function () {
				this.address_popup = true;
				this.account_popup = true;
			},

			edit_address: function (
				id,
				name,
				address,
				city,
				state,
				pin,
				phone,
				add_default
			) {
				this.user.address_id = id;
				this.user.name = name;
				this.user.address = address;
				this.user.pin_code = pin;
				this.user.city = city;
				this.user.state = state;
				this.user.phone = phone;
				this.user.default = add_default;
				this.address_popup = false;
				this.user_name();
				this.user_city();
				this.user_address();
				this.user_pin_code();
				this.user_phone();
			},
			user_name: function () {
				var name = /^([^\s]+[a-z ,A-Z, ])+$/;
				if (this.user.name.match(name)) {
					this.name_error = "";
				} else {
					this.name_error = "Please enter valid Name";
				}
			},
			cust_name: function () {
				var name = /^([^\s]+[a-z ,A-Z, ])+$/;
				if (this.customer_name.match(name)) {
					this.name_error = "";
				} else {
					this.name_error = "Please enter valid Name";
				}
			},
			cust_email: function () {
				var email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				if (this.customer_email.match(email)) {
					this.email_error = "";
				} else {
					this.email_error = "Please enter valid Email";
				}
			},
			cust_phone: function () {
				var phoneno = /^([0-9]{10,})+$/;
				if (this.customer_phone.match(phoneno)) {
					this.phone_error = "";
				} else {
					this.phone_error = "Please enter valid Phone Number";
				}
			},
			edit_contact: function () {
				this.isEdit = true;
				this.cust_name();
				this.cust_email();
				this.cust_phone();
			},
			update_contact: function () {
				if (
					this.customer_name != "" &&
					this.customer_email != "" &&
					this.customer_phone != "" &&
					this.name_error == "" &&
					this.email_error == "" &&
					this.phone_error == ""
				) {
					this.$root.error_message = "";
					this.$root.success_message = "";
					this.$root.page_loader = true;
					var form = new FormData();
					form.append("customer_id", this.$root.customer_id);
					form.append("customer_session", this.$root.customer_session);
					form.append("full_name", this.customer_name);
					form.append("email", this.customer_email);
					form.append("phone", this.customer_phone);
					axios
						.post(this.$root.cart_api + "/customer/update-customer", form)
						.then((response) => {
							if (response.data.success === true) {
								this.isEdit = false;
								this.$root.success_message = response.data.message;
								this.address = response.data.data.address;
								this.$root.error_message = "";
								this.$root.page_loader = false;
								this.address_popup = true;
								this.customer_email = response.data.data.email;
								this.customer_phone = response.data.data.phone;
								this.customer_name = response.data.data.full_name;
								this.$root.customerName = response.data.data.full_name;
								this.shipping_address.address_id = response.data.data.maddress.id;
								this.shipping_address.name =
									response.data.data.maddress.full_name;
								this.shipping_address.address =
									response.data.data.maddress.street_address;
								this.shipping_address.pincode =
									response.data.data.maddress.pin_code;
								this.shipping_address.city = response.data.data.maddress.city;
								this.shipping_address.state = response.data.data.maddress.state;
								this.shipping_address.phone = response.data.data.maddress.phone;
								this.shipping_address.default =
									response.data.data.maddress.default;
								window.scrollTo(0, 0);
							} else {
								this.$root.error_message = response.data.message;
								this.$root.success_message = "";
								this.$root.page_loader = false;
								if (response.data.customer_session_status == false) {
									this.$cookies.set(
										window.location.hostname.substring(10, 4) + "_customer",
										"",
										"1y"
									);
									this.$cookies.set(
										window.location.hostname.substring(10, 4) + "_cs",
										"",
										"1y"
									);
									this.$root.customer_id = "";
									this.$root.customer_session = "";
									this.$cookies.set(
										window.location.hostname.substring(10, 4) + "_cart",
										"",
										"1y"
									);
									this.$cookies.set(
										window.location.hostname.substring(10, 4) + "_carts",
										"",
										"1y"
									);
									this.$root.pcart = "";
									this.$root.cart_session = "";
									this.$root.cart_product = [];
									this.$router.push("/");
								}
							}
						})
						.catch((error) => {
							this.$root.page_loader = false;
							if (error.message === "Network Error") {
								this.$root.error_message = error.message;
							}
							window.scrollTo(0, 0);
						});
				}
			},
			user_city: function () {
				var city = /^([^\s]+[a-z ,A-Z, ])+$/;
				if (this.user.city.match(city)) {
					this.city_error = "";
				} else {
					this.city_error = "Please enter valid City";
				}
			},
			user_address: function () {
				var address = /^([^\s]+[a-z A-Z 1-9 ])+$/;
				if (this.user.address.match(address)) {
					this.address_error = "";
				} else {
					this.address_error = "Please enter valid Address";
				}
			},
			user_pin_code: function () {
				var pin_code = /^([0-9]{6,})+$/;
				if (this.user.pin_code.match(pin_code)) {
					this.$root.error_message = "";
					this.$root.success_message = "";
					axios
						.get(this.$root.api_url + `/pim/pimresponse.php`, {
							params: {
								service: "pincheck",
								store: this.$root.store,
								pincode: this.user.pin_code,
							},
						})
						.then((response) => {
							if (response.data.result == "") {
								this.pin_code_error = "Sorry this pincode is not serviceable.";
							} else {
								this.user.city = response.data.result.city;
								this.user.state = response.data.result.state;
								this.pin_code_error = "";
								this.state_error = "";
								if (response.data.result.city != "") {
									this.city_error = "";
								}
							}
						})
						.catch((error) => {
							if (error.message === "Network Error") {
								this.$root.error_message = error.message;
							}
							window.scrollTo(0, 0);
						});
				} else {
					this.pin_code_error = "Please enter valid Pin code";
				}
			},
			user_phone: function () {
				var phoneno = /^([0-9]{10,})+$/;
				if (this.user.phone.match(phoneno)) {
					this.phone_error = "";
				} else {
					this.phone_error = "Please enter valid Phone Number";
				}
			},
			update_address: function () {
				if (
					this.user.name != "" &&
					this.user.address != "" &&
					this.user.pin_code != "" &&
					this.user.city != "" &&
					this.user.state != "" &&
					this.user.phpne != "" &&
					this.name_error == "" &&
					this.address_error == "" &&
					this.pin_code_error == "" &&
					this.city_error == "" &&
					this.state_error == "" &&
					this.phone_error == ""
				) {
					this.$root.error_message = "";
					this.$root.success_message = "";
					this.$root.page_loader = true;
					var form = new FormData();
					form.append("customer_id", this.$root.customer_id);
					form.append("customer_session", this.$root.customer_session);
					form.append("address_id", this.user.address_id);
					form.append("full_name", this.user.name);
					form.append("street_address", this.user.address);
					form.append("pin_code", this.user.pin_code);
					form.append("city", this.user.city);
					form.append("state_name", this.user.state);
					form.append("phone", this.user.phone);
					form.append("default", this.user.default);
					axios
						.post(this.$root.cart_api + "/customer/edit-address", form)
						.then((response) => {
							if (response.data.success === true) {
								this.$root.success_message = response.data.message;
								this.address = response.data.data.address;
								this.$root.error_message = "";
								this.$root.page_loader = false;
								this.address_popup = true;
								this.customer_email = response.data.data.email;
								this.customer_phone = response.data.data.phone;
								this.customer_name = response.data.data.full_name;
								this.shipping_address.address_id = response.data.data.maddress.id;
								this.shipping_address.name =
									response.data.data.maddress.full_name;
								this.shipping_address.address =
									response.data.data.maddress.street_address;
								this.shipping_address.pincode =
									response.data.data.maddress.pin_code;
								this.shipping_address.city = response.data.data.maddress.city;
								this.shipping_address.state = response.data.data.maddress.state;
								this.shipping_address.phone = response.data.data.maddress.phone;
								this.shipping_address.default =
									response.data.data.maddress.default;
								window.scrollTo(0, 0);
							} else {
								this.$root.error_message = response.data.message;
								this.$root.success_message = "";
								this.$root.page_loader = false;
								if (response.data.customer_session_status == false) {
									this.$cookies.set(
										window.location.hostname.substring(10, 4) + "_customer",
										"",
										"1y"
									);
									this.$cookies.set(
										window.location.hostname.substring(10, 4) + "_cs",
										"",
										"1y"
									);
									this.$root.customer_id = "";
									this.$root.customer_session = "";
									this.$cookies.set(
										window.location.hostname.substring(10, 4) + "_cart",
										"",
										"1y"
									);
									this.$cookies.set(
										window.location.hostname.substring(10, 4) + "_carts",
										"",
										"1y"
									);
									this.$root.pcart = "";
									this.$root.cart_session = "";
									this.$root.cart_product = [];
									this.$router.push("/");
								}
							}
						})
						.catch((error) => {
							this.$root.page_loader = false;
							if (error.message === "Network Error") {
								this.$root.error_message = error.message;
							}
							window.scrollTo(0, 0);
						});
				}
			},
			get_account: function () {
				if (this.$root.customer_id != null && this.$root.customer_id != "") {
					this.$root.error_message = "";
					this.$root.success_message = "";
					this.$root.page_loader = true;
					var form = new FormData();
					form.append("customer_id", this.$root.customer_id);
					form.append("customer_session", this.$root.customer_session);
					form.append("store", this.$root.store);
					axios
						.post(this.$root.cart_api + "/customer/account-details", form)
						.then((response) => {
							if (response.data.success === true) {
								console.log("test")
								this.profileLoader = false;
								this.$root.page_loader = false;
								this.order = response.data.data.orders;
								this.customer_email = response.data.data.email;
								this.customer_phone = response.data.data.phone;
								this.$root.storeCredit = response.data.data.storeCredit;
								if (response.data.data.full_name != null) {
									this.customer_name = response.data.data.full_name;
								}
								this.shipping_address.address_id = response.data.data.maddress.id;
								this.shipping_address.name =
									response.data.data.maddress.full_name;
								this.shipping_address.address =
									response.data.data.maddress.street_address;
								this.shipping_address.pincode =
									response.data.data.maddress.pin_code;
								this.shipping_address.city = response.data.data.maddress.city;
								this.shipping_address.state = response.data.data.maddress.state;
								this.shipping_address.phone = response.data.data.maddress.phone;
								this.shipping_address.default =
									response.data.data.maddress.default;
									
							} else {
								this.$root.page_loader = false;
								this.$root.error_message = response.data.message;
								if (response.data.customer_session_status == false) {
									this.$cookies.set(
										window.location.hostname.substring(10, 4) + "_customer",
										"",
										"1y"
									);
									this.$cookies.set(
										window.location.hostname.substring(10, 4) + "_cs",
										"",
										"1y"
									);
									this.$root.customer_id = "";
									this.$root.customer_session = "";
									this.$cookies.set(
										window.location.hostname.substring(10, 4) + "_cart",
										"",
										"1y"
									);
									this.$cookies.set(
										window.location.hostname.substring(10, 4) + "_carts",
										"",
										"1y"
									);
									this.$root.pcart = "";
									this.$root.cart_session = "";
									this.$root.cart_product = [];
									
									this.$router.push("/");
								}
							
							}
							
						})
						.catch((error) => {
							this.$root.page_loader = false;
							if (error.message === "Network Error") {
								this.$root.error_message = error.message;
							}
							window.scrollTo(0, 0);
						});
				}
			},
		},
		mounted() {
			this.get_account();
		},
		created() {
			window.scrollTo(0, 0);
			if (this.$root.customer_id === null || this.$root.customer_id === "") {
				this.$router.push("/");
			}
			(this.$root.error_message = ""),
				(this.$root.success_message = ""),
				(this.$root.breadcrumb = "My Account"),
				(this.$root.page_loader = false);
		},
	};
</script>


<style scoped>

@media screen and (max-width: 767px){
.linksContainer { 
	display: grid;
    width: 100%;
    grid-template-columns: 1fr 1fr;
    background: #fff;
    justify-items: center;
    align-items: center;
}

.linksContainer  .accountLinks{
	width: 100% !important;
 } 
}
</style>